// OutletOrderHistoryTable2.jsx
import React from "react";
import Pagination from "./Pagination";
import { Link } from "react-router-dom";
import {
  renderTruncatedText,
  reverseStatusLookup,
  StatusBadge,
} from "../utils/tableUtils";

const OutletOrderHistoryTable2 = ({
  headers,
  data = [],
  currentPage,
  totalCount,
  pageSize = 15,
  onPageChange,
  handleCancelTrip,
}) => {
  const formatUKTime = (timeString, fallback = "—") => {
    if (!timeString) return fallback;
    const date = new Date(timeString);
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "Europe/London",
    });
  };

  return (
    <>
      <div className="border-2 border-t-4 border-quaternary bg-[#F7F9F8] text-[#413F3F] overflow-x-scroll relative rounded-xl h-full overflow-auto px-3">
        <div className="flex flex-col">
          <div className="w-full rounded-t-lg">
            <table className="w-full table-auto divide-y divide-gray-200 dark:divide-gray-700">
              <thead>
                <tr>
                  {headers.map((header, index) => (
                    <th
                      key={index}
                      className="text-start text-[14px] font-bold leading-5 px-4 py-1 h-12 whitespace-nowrap"
                    >
                      {header}
                    </th>
                  ))}
                  <th></th>
                </tr>
              </thead>
              {data.length > 0 ? (
                <tbody className="divide-y-[1px] divide-[#8D8D8D]">
                  {data.map((item, index) => (
                    <tr
                      key={index}
                      className={`${index % 2 === 0 ? "bg-gray-100" : ""}`}
                    >
                      <td className="px-4 py-4 text-sm font-medium">
                        {item?.orderId}
                      </td>
                      <td className="px-4 py-4 text-sm font-medium">
                        <StatusBadge
                          status={reverseStatusLookup(item?.status)}
                        />
                      </td>
                      <td className="px-4 py-4 text-sm font-medium truncate max-w-xs capitalize">
                        {item?.outlet || "—"}
                      </td>
                      <td className="px-4 py-4 text-sm font-medium truncate max-w-xs capitalize">
                        {renderTruncatedText(item?.customer_name) || "—"}
                      </td>
                      <td className="px-4 py-4 text-sm font-medium truncate max-w-xs capitalize">
                        {item?.driver || "—"}
                      </td>
                      <td className="px-4 py-4 text-sm font-medium">
                        {(item?.ee_share && `£${item?.ee_share}`) || "£0"}
                      </td>
                      <td className="px-4 py-4 text-sm font-medium">
                        {(item?.delivery_charge &&
                          `£${item?.delivery_charge}`) ||
                          "—"}
                      </td>
                      <td className="px-4 py-4 text-sm font-medium whitespace-nowrap">
                        {formatUKTime(item?.order_time)}
                      </td>
                      <td className="px-4 py-4 text-sm font-medium whitespace-nowrap">
                        {item?.status === "Delivered"
                          ? formatUKTime(item?.delivery_time)
                          : "In progress"}
                      </td>
                      <td className="px-4 py-4 text-sm font-medium">
                        {[
                          "Driver Assigned",
                          "Driver Approaching",
                          "Driver Arrived",
                          "Picked Up",
                          "Driver Departed",
                        ].includes(reverseStatusLookup(item?.status)) ? (
                          <button
                            onClick={() => handleCancelTrip(item)}
                            className="bg-[#F35555] text-white font-semibold w-full py-1.5 rounded-md shadow-[rgba(50,50,93,0.25)_0px_6px_12px_-2px,_rgba(0,0,0,0.3)_0px_3px_7px_-3px] whitespace-nowrap text-center flex justify-center"
                          >
                            Cancel Trip
                          </button>
                        ) : reverseStatusLookup(item?.status) ===
                          "Cancelled" ? (
                          <Link
                            to={`/allocate-new-driver/${item?._id}`}
                            className="bg-[#F35555] text-white font-semibold w-full py-1.5 rounded-md shadow-[rgba(50,50,93,0.25)_0px_6px_12px_-2px,_rgba(0,0,0,0.3)_0px_3px_7px_-3px] whitespace-nowrap text-center flex justify-center"
                          >
                            Allocate driver
                          </Link>
                        ) : (
                          <Link
                            to={`/orders/${item?._id}`}
                            className="bg-quaternary text-white font-semibold w-full py-1.5 rounded-md shadow-[rgba(50,50,93,0.25)_0px_6px_12px_-2px,_rgba(0,0,0,0.3)_0px_3px_7px_-3px] whitespace-nowrap text-center flex justify-center"
                          >
                            Details
                          </Link>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td
                      colSpan={headers.length}
                      className="px-3 py-4 italic text-sm font-medium text-center"
                    >
                      Still no orders — maybe everyone's just on a very long
                      'diet' today.
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
        </div>
      </div>
      <div className="flex justify-center">
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={totalCount}
          pageSize={pageSize}
          onPageChange={onPageChange}
        />
      </div>
    </>
  );
};

export default OutletOrderHistoryTable2;
